import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Box } from '@mui/material';
import { useContent } from '../context/ContentContext';
import Header from './Header';
import Footer from './Footer';

const Layout = () => {
  const { content } = useContent();
  const { site } = content;
  const location = useLocation();

  // 处理路由变化时的锚点滚动
  useEffect(() => {
    // 检查URL中是否有锚点
    if (location.hash) {
      // 去掉#号
      const id = location.hash.substring(1);
      const element = document.getElementById(id);
      
      if (element) {
        // 给DOM一点时间来渲染
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 300);
      }
    } else {
      // 如果没有锚点，滚动到页面顶部
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>{site.title} - {site.description}</title>
        <meta name="description" content={site.description} />
        <link rel="icon" href={site.favicon} />
      </Helmet>
      
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        minHeight: '100vh'
      }}>
        <Header />
        
        <Box component="main" sx={{ 
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column'
        }}>
          <Outlet />
        </Box>
        
        <Footer />
      </Box>
    </>
  );
};

export default Layout; 